import { useState } from 'react';
import { usePovijestKucanstva } from '../hooks/usePodaci';
import { grupirajPovijest, naslovPromjene, razlikeZapisa, vrijemePromjene } from '../lib/povijest';

export default function PovijestKucanstva({ kucanstvo }) {
  const [otvoreno, postaviOtvoreno] = useState(false);
  const stanje = usePovijestKucanstva(otvoreno ? kucanstvo.id : null, kucanstvo.updated_at);
  const grupe = grupirajPovijest(stanje.zapisi);
  return (
    <section className="povijest-kucanstva" aria-label="Povijest izmjena kućanstva">
      <button type="button" className="tekst-gumb" aria-expanded={otvoreno}
        onClick={() => postaviOtvoreno(!otvoreno)}>
        {otvoreno ? 'Sakrij povijest izmjena' : 'Prikaži povijest izmjena'}
      </button>
      {otvoreno && <>
        <h4>Povijest izmjena</h4>
        <p className="napomena-povijesti">Prikazuju se promjene od uključivanja povijesti. Ranije izmjene nisu zabilježene.</p>
        <button type="button" className="tekst-gumb" onClick={stanje.osvjezi} disabled={stanje.ucitava}>Osvježi povijest</button>
        {stanje.greska && <p role="alert">Povijest nije dostupna. {stanje.greska}</p>}
        {stanje.ucitava && <p role="status">Učitavam povijest…</p>}
        {!stanje.ucitava && !stanje.greska && !grupe.length && <p>Nema zabilježenih izmjena.</p>}
        <ol className="popis-povijesti">
          {grupe.map((g) => <li key={g.kljuc}>
            <strong>{g.korisnik}</strong>
            <time dateTime={g.vrijeme}>{vrijemePromjene(g.vrijeme)}</time>
            {g.zapisi.map((z) => <details key={z.id}>
              <summary>{naslovPromjene(z)}</summary>
              <dl className="razlike-povijesti">
                {razlikeZapisa(z.prije, z.poslije).map((r) => <div key={r.kljuc}>
                  <dt>{r.naziv}</dt>
                  <dd><span className="stara-vrijednost">Prije: {r.prije}</span><span>Poslije: {r.poslije}</span></dd>
                </div>)}
              </dl>
            </details>)}
          </li>)}
        </ol>
        {stanje.imaJos && <button type="button" className="gumb sek" disabled={stanje.ucitava} onClick={stanje.ucitajJos}>Učitaj starije promjene</button>}
      </>}
    </section>
  );
}
